// The message for a declined payment: the member came back from Slimpay
// without signing the SEPA mandate (mandate_not_signed, from memberships),
// otherwise a plain decline
const paymentDeclinedKey = (reason) =>
  reason === 'mandate_not_signed' ? 'signup.payment.mandate_not_signed' : 'signup.payment.payment_declined'

export default paymentDeclinedKey
